import { render, staticRenderFns } from "./notice-item.vue?vue&type=template&id=559a1dfb"
import script from "./notice-item.vue?vue&type=script&lang=js"
export * from "./notice-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports